/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
import React, { useState, useEffect } from "react"
import {
  View,
  Text,
  TouchableOpacity,
  Image,
  ActivityIndicator,
  Dimensions,
  Platform,
} from "react-native"
import LinearGradient from "react-native-linear-gradient"
import moment from "moment"
import { Bar } from "react-native-progress"
import { colors } from "colors"
import { useColor } from "app/theme/getThemes"
import { useNavigation } from "@react-navigation/native"
import { style } from "../screens/Application/Member/styles"
import expired from "../../assets/expired.png"
import { lowerFirst } from "lodash"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"

const TierCard = ({ loading, tierLevel, home = false }) => {
  const { companyTheme } = useColor()
  const navigation = useNavigation<any>()

  const tierColor = {
    gold: ["#FFF5B7", "#FFD700", "#FFB14E", "#D99200"],
    silver: ["#E0E0E0", "#C0C0C0", "#A9A9A9", "#D4D4D4"],
    bronze: ["#E3B778", "#CD7F32", "#D8A162", "#A76B29"],
  }
  console.log("INFO: ", tierLevel?.[0])
  const currentTier = tierLevel?.[0]?.currentTier
  const tierColors = tierColor[currentTier] || [companyTheme.first, companyTheme.second]

  const maintainAmount = tierLevel?.[0]?.allData?.maintain_amount
  const sumSales = tierLevel?.[0]?.allData?.sum_sales
  const nextTierAmount = tierLevel?.[0]?.allData?.next_tier_amt ?? "MAX"
  const nextTier = tierLevel?.[0]?.allData?.next_tier_id
  const isStatic = tierLevel?.[0]?.allData?.is_static

  const getProgress = () => {
    if (nextTier) {
      if (sumSales === 0) {
        return 0
      } else if (nextTierAmount === "MAX") {
        return 1
      } else {
        return sumSales / nextTierAmount
      }
    } else if (isStatic) {
      return 1
    } else {
      return sumSales / maintainAmount
    }
  }

  const [tierStatus, setTierStatus] = useState("normal")

  const getTierStatus = () => {
    if (tierLevel?.[0]?.allData?.is_maintained) {
      setTierStatus("maintained")
    } else if (tierLevel?.[0]?.allData?.is_upgraded) {
      setTierStatus("upgraded")
    } else if (tierLevel?.[0]?.allData?.is_demoted) {
      setTierStatus("demoted")
    } else {
      setTierStatus("normal")
    }
  }

  useEffect(() => {
    getTierStatus()
  }, [tierLevel])

  const getProgressText = () => {
    if (sumSales > maintainAmount) {
      return "You have maintained your current tier"
    } else if (nextTierAmount === "MAX") {
      return "You have reached the max tier"
    } else {
      return `Accumulate RM ${sumSales} / RM ${
        maintainAmount > 0 ? maintainAmount : nextTierAmount
      } to ${
        nextTierAmount === "MAX"
          ? "maintain your current tier"
          : `reach the ${lowerFirst(tierLevel?.[0].nextTierName || tierLevel?.[0]?.nextTier)} tier`
      }`
    }
  }

  const progress = getProgress()

  const currentTierColor = companyTheme.first

  const expiry = !tierLevel?.[0]?.allData?.membership_expiry_date
    ? false
    : moment(tierLevel?.[0]?.expiry).isSameOrBefore(moment())

  console.log("tierLevel", tierLevel?.[0]?.nextTier)
  return (
    <>
      <TouchableOpacity
        style={[
          loading && style.borderContainer,
          { alignItems: "center", justifyContent: "center" },
        ]}
        onPress={() => (home ? navigation.navigate("member") : navigation.navigate("memberShip"))}
      >
        <LinearGradient
          style={[
            style.tierContentContainer,
            {
              padding: 0,
              overflow: "hidden",
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 4 },
              shadowOpacity: 0.3,
              shadowRadius: 6,
              marginBottom: 10,
              opacity: !loading && expiry ? 0.5 : 1,
            },
          ]}
          colors={tierColors}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        >
          {loading ? (
            <View
              style={{ width: "100%", alignItems: "center", justifyContent: "center", height: 200 }}
            >
              <ActivityIndicator size={"large"} color={"white"} />
            </View>
          ) : (
            <>
              <View
                style={{
                  display: "flex",
                  padding: "5%",
                  width: "100%",
                  marginBottom: "5%",
                  position: "relative",
                  zIndex: 999,
                }}
              >
                <View>
                  <Text style={[style.tierSpendText, { color: "black", fontSize: 12 }]}>
                    {getProgressText()}
                  </Text>
                </View>
                <Bar
                  progress={nextTierAmount === "MAX" ? 1 : progress || 0}
                  width={null}
                  color={"#ffb09c"}
                  unfilledColor="#E0E0E0"
                  borderWidth={0}
                  height={8}
                  style={{ marginTop: 8 }}
                />
                <View>
                  {/* {tierLevel?.[0]?.expiry && (
                    <Text
                      style={[style.tierSpendText, { color: "black", fontSize: 12, marginTop: 10 }]}
                    >
                      Member Expires at : {moment(tierLevel?.[0]?.expiry).format("DD-MMM-YYYY")}
                    </Text>
                  )}
                  {/* {tierLevel?.[0]?.allData?.tier_expiry_date && (
                    <Text
                      style={[style.tierSpendText, { color: "white", fontSize: 12, marginTop: 10 }]}
                    >
                      Tier Expire at :{" "}
                      {moment(tierLevel?.[0]?.allData?.tier_expiry_date).format("DD-MMM-YYYY")}
                    </Text>
                  )} */}
                </View>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "5%",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  position: "relative",
                  zIndex: 999,
                }}
              >
                <Text style={[style.tierSpendText, { color: "white", fontSize: 25 }]}>
                  {tierLevel?.[0].currentTier?.toLocaleUpperCase()}
                  {tierStatus === "maintained" && (
                    <MaterialCommunityIcons name="check-circle" size={24} color="green" />
                  )}
                  {tierStatus === "upgraded" && (
                    <MaterialCommunityIcons name="arrow-up-bold-circle" size={24} color="green" />
                  )}
                  {tierStatus === "demoted" && (
                    <MaterialCommunityIcons name="arrow-down-bold-circle" size={24} color="red" />
                  )}
                </Text>
                <View>
                  <Image
                    source={{ uri: tierLevel?.[0]?.icon }}
                    resizeMode="contain"
                    style={[
                      style.voucherImage,
                      { width: 70, height: 70, backgroundColor: `${tierColors?.[0]}` },
                    ]}
                  />
                </View>
              </View>
            </>
          )}
          <View
            style={{
              position: "absolute",
              width: 200,
              height: 200,
              borderRadius: 100,
              backgroundColor: `${tierColor[tierLevel?.[0]?.currentTier]?.[0]}`,
              opacity: 0.2,
              bottom: -80,
              left: -50,
              zIndex: 1,
            }}
          />
          <View
            style={{
              position: "absolute",
              width: 200,
              height: 200,
              borderRadius: 100,
              backgroundColor: `${tierColor[tierLevel?.[0]?.currentTier]?.[3]}`,
              opacity: 0.2,
              top: -80,
              right: -50,
              zIndex: 1,
            }}
          />
        </LinearGradient>
        {!loading && (
          <View
            style={{
              width: "100%",
              paddingBottom: 10,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text style={{ color: colors.lightGrey }}>
              Click the card to show all others' tier benefits
            </Text>
          </View>
        )}
        <View
          style={{
            maxWidth: 500,
            width: "100%",
            height: "100%",
            position: "absolute",
          }}
        >
          {!loading && expiry && (
            <Image
              source={Platform.OS === "web" ? { uri: expired } : expired}
              resizeMode="cover"
              style={{
                width: 80,
                height: 80,
                right: 10,
                position: "absolute",
                bottom: 50,
                zIndex: 999,
                opacity: 0.8,
              }}
            />
          )}
        </View>
      </TouchableOpacity>
    </>
  )
}

export default TierCard
